<template>
  <div>
    <v-text-field
      :ref="refProp"
      v-bind="tfProps"
      :color="color"
      :hideDetails="hideDetails"
      :outlined="outlined"
      :rules="rules"
      :placeholder="placeholder"
      :label="label"
      :password="password"
      :appendIcon="scopedAppendIcon"
      :validate-on-blur="validateOnBlur"
      :type="scopedType"
      v-on="$listeners"
      @click:append="clickAppendHandler"
      @input="passWordCheck"
    >
      <template v-for="slot in slots__" v-slot:[slot]>
        <slot :name="slot" />
      </template>
    </v-text-field>
    <b-popover
      ref="popoverEl"
      v-if="popover && mounted"
      v-bind="pProps"
      v-on="pListeners"
    >
      <ul>
        <li v-for="m in popoverMessages" :key="m.id">
          {{ m }}
        </li>
      </ul>
    </b-popover>
  </div>
</template>

<script>
import { VTextField } from "vuetify/lib";
import Util from "@/components/Util.js";

export default {
  emits: ["password-check"],
  components: { VTextField },
  data: () => ({
    slots__: [
      "default",
      "append",
      "append-outer",
      "label",
      "message",
      "prepend",
      "prepend-inner",
      "progress",
    ],
    showPass: false,
    mounted: false,
  }),
  props: {
    refProp: {
      type: String,
      default: "textFieldEl",
    },
    color: {
      type: String,
      default: "#212121",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: [Boolean, String],
      default: "auto",
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    password: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    popover: {
      type: Boolean,
      default: false,
    },
    defaultBg: {
      type: String,
      default: "rgba(0, 0, 0, 0)",
    },
    popoverProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    popoverListeners: {
      type: Object,
      default: () => {
        return {};
      },
    },
    popoverMessages: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.mountedHandler();
  },
  computed: {
    tfProps() {
      var _keys = [
        "outlined",
        "hideDetails",
        "color",
        "appendIcon",
        "type",
        "popover",
        "popoverProps",
        "popoverListeners",
        "popoverMessages",
      ];
      return Util.filterProps(this, _keys);
    },
    scopedAppendIcon() {
      if (this.password) {
        return this.showPass ? "mdi-eye" : "mdi-eye-off";
      }
      return this.$props.appendIcon;
    },
    scopedType() {
      if (this.password) {
        return this.showPass ? "text" : "password";
      }
      return this.$props.type;
    },
    pListeners() {
      const _popover = this.$refs.popoverEl;
      const _listeners = (_popover && _popover.$listeners) || {};
      return Object.assign({}, _listeners, this.popoverListeners);
    },
    pProps() {
      const _textfield = this.$refs.textFieldEl;
      const baseProps = {
        fallbackPlacement: ["right", "bottom"],
        triggers: ["hover", "focus"],
        container: "app",
        placement: "right",
        boundaryPadding: "0.5rem",
        target: _textfield,
      };
      return Object.assign({}, baseProps, this.popoverProps);
    },
  },
  methods: {
    passWordCheck(event) {
      this.$emit("password-check", event);
    },
    clickAppendHandler() {
      this.showPass = !this.showPass;
    },
    mixedProps(props) {
      return Object.assign({}, props, this.tfProps);
    },
    mixedListeners(listeners) {
      return Object.assign({}, listeners, this.$listeners);
    },
    activateField() {
      const textField = this.$refs.textFieldEl.$el;
      const label = textField.querySelector(".v-text-field__slot label");
      const legend = textField.querySelector(".v-input__slot legend");
      textField.classList.add("v-input--is-dirty", "v-input--is-label-active");
      label.classList.add("v-label--active");

      setTimeout(() => {
        const value = Number(Util.getStyle(label, "width").slice(0, -2));
        legend.style.width = value * 0.8 + 3 + "px";
      }, 80);
    },
    mountedHandler() {
      const self = this;

      self.mounted = true;

      self.$nextTick(() => {
        setTimeout(() => {
          const textFieldEl = self.$refs.textFieldEl;
          const input = textFieldEl && textFieldEl.$refs.input;
          if (
            input &&
            Util.getStyle(input, "background-color") !== self.defaultBg
          ) {
            self.activateField();
          }
        }, 100);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-text-field.v-text-field--enclosed {
  margin-bottom: 1.5rem;
  .v-input__control {
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
  .v-input__append-inner {
    padding-left: 0.75rem;
  }
  .v-input__prepend-inner {
    padding-right: 0.5rem;
  }
  &:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding-right: 0.75rem;
    margin-bottom: 0;
  }
  .v-text-field__details {
    padding: 0;
    margin-top: 0.4375rem;
    margin-bottom: 0;
  }
}
.popover {
  min-width: 391px;
}
</style>
